const Emitter = require('mn-utils/Emitter');
const {
  DEFAULT_CASH,
  apiBankName,
  apiCashFee,
  apiCashAmount,
  apiWithdraw,
} = require('../api/merchant/cash');
const decorateByLoading = require('./utils/decorateByLoading');


export const loadingCashFeeGet$ = new Emitter();
export const cashFee$ = new Emitter(() => {
  cashFeeUpdate();
}, 0);
export const cashFeeUpdate = decorateByLoading(
    apiCashFee,
    loadingCashFeeGet$,
    (response) => {
      cashFee$.emit(response.fee);
    },
);

export const loadingBankNameGet$ = new Emitter();
export const bankName$ = new Emitter(() => {
  bankNameUpdate();
}, 0);
export const bankNameUpdate = decorateByLoading(
    apiBankName,
    loadingBankNameGet$,
    (response) => {
      bankName$.emit(response.name);
    },
);


export const loadingCashGet$ = new Emitter();
export const loadingCashWithdraw$ = new Emitter();
export const loadingCash$ = Emitter.some([
  loadingCashGet$,
  loadingCashWithdraw$,
]);

export const cash$ = new Emitter(() => {
  cashUpdate();
}, DEFAULT_CASH);
export const cashUpdate = decorateByLoading(
    apiCashAmount,
    loadingCashGet$,
    (response) => {
      cash$.emit(response);
    },
);

export const cashWithdraw = decorateByLoading(
    apiWithdraw,
    loadingCashWithdraw$,
    () => {
      cashUpdate();
    },
);
